module.exports = __webpack_public_path__ + "img/album_select.240a0a3a.svg";